module.exports = __webpack_public_path__ + "static/media/implants.f488d50a.png";